import { cleanupInitialState, getISconfig, getInitialState } from './namespace';
import { isObject } from './utils';
/**
 * Optional storage config
 */
export const getGlobalConfig = () => (isObject(getISconfig()) ? getISconfig() : null);
export const isAvailable = (identificator) => {
    var _a;
    const availables = (_a = getGlobalConfig()) === null || _a === void 0 ? void 0 : _a.available;
    return !availables || ~availables.indexOf(identificator);
};
/**
 * Use optional INIT object, copy data and clean it up
 */
export const pullInitialIdentities = () => {
    const initIdentities = getInitialState();
    if (!initIdentities) {
        return {};
    }
    const output = Object.assign({}, initIdentities);
    cleanupInitialState();
    return output;
};
